import * as React from "react"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

const CompactField = React.forwardRef(({
  label,
  value,
  onChange,
  placeholder,
  className,
  editable = true,
  ...props
}, ref) => {
  const [isEditing, setIsEditing] = React.useState(false)
  const [editValue, setEditValue] = React.useState(value || '')

  React.useEffect(() => {
    setEditValue(value || '')
  }, [value])

  const handleSave = () => {
    if (onChange) {
      onChange(editValue)
    }
    setIsEditing(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave()
    } else if (e.key === 'Escape') {
      setEditValue(value || '')
      setIsEditing(false)
    }
  }

  const handleClick = () => {
    if (editable) {
      setIsEditing(true)
    }
  }

  return (
    <div className={cn("flex items-center justify-between gap-2", className)}>
      <div className="text-sm font-medium text-gray-700 min-w-0 flex-shrink-0">
        {label}
      </div>
      {isEditing ? (
        <Input
          ref={ref}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="text-sm h-8 flex-1"
          autoFocus
          {...props}
        />
      ) : (
        <div
          className={cn(
            "text-sm text-gray-900 flex-1 text-right truncate",
            editable && "cursor-pointer hover:text-gray-600 transition-colors"
          )}
          onClick={handleClick}
          title={value}
        >
          {value || <span className="text-gray-400 italic">{placeholder || "Click to edit"}</span>}
        </div>
      )}
    </div>
  )
})

CompactField.displayName = "CompactField"

export { CompactField }